import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateUpsellMetaType extends Enum {
  static ESTATE_UPSELL_CLEAR_WILL_META = 'EstateUpsellClearWillMeta';

  static ESTATE_UPSELL_CLEAR_ESTATE_META = 'EstateUpsellClearEstateMeta';
}
